<template>
  <!-- 卫星系列 -->
  <div class="mapResult">
    <div class="resultBtn">
      <!-- <el-button
        type="primary"
        :icon="iconSrc"
        circle
        @click="changeResult"
        :loading="resultState"
      ></el-button> -->
      <el-button type="primary" :icon="iconSrc" @click="changeResult" :loading="resultState">查询结果</el-button>
    </div>
    <div class="mapResultWrap" :class="currentState ? 'animateLeft' : ''" v-loading="searchDataLoading" element-loading-text="产品加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
      <div class="resultTitle">
        <span><span class="beforeIcon"></span>查询结果</span>
      </div>
      <div class="resultList" v-if="nothingSwitch" v-loading="joinCarLoad">
        <!-- 单一查询结果 -->
        <div class="resultBox" v-for="(item,index) in imageInfoData" :key="index">
          <div class="item">
            <div class="selectedSingleBuyCar">
              <!-- 新增点击显示图像 -->
              <!-- <el-checkbox @change="selectGoodFun(item.goodsId)">
              </el-checkbox> -->
              <div :class="selectedImage.includes(item.goodsId)?'check_Have':'check_Not'" @click="selectGoodFun(item.goodsId)">
                <i class="el-icon-check" style="color: rgb(255, 255, 255);font-size: 12px;position: absolute;top: 3px;left: 1px;"></i>
              </div>
              <img class="imageClass" @click="changeImageSwitchFun(item)" :src="item.goodsThumbnail" alt="" />
            </div>
          </div>
          <div class="item">
            <!-- 查看详情 -->
            <div class="rightArrow" @click="lookDetail(item.goodsId)" title="点击查看详情">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="itemText">
              <div class="textItem">
                <span>产品名称：</span>
              </div>
              <div class="textItem">
                <span :title="item.goodsName">{{ item.goodsName }}</span>
              </div>
            </div>
            <div class="itemText">
              <div class="textItem">
                <span>卫星名称：</span>
              </div>
              <div class="textItem">
                <span :title="item.satelliteName">{{ item.satelliteName }}</span>
              </div>
            </div>
            <div class="itemText">
              <div class="textItem">
                <span>云量：</span>
              </div>
              <div class="textItem">
                <span>{{ item.cloudCover }}</span>
              </div>
            </div>
            <div class="itemText">
              <div class="textItem">
                <span>采集时间：</span>
              </div>
              <div class="textItem">
                <span>{{ item.acquisitionTime }}</span>
              </div>
            </div>
            <div class="itemText">
              <div class="textItem">
                <span>产品等级：</span>
              </div>
              <div class="textItem">
                <span>{{ item.productLevel }}</span>
              </div>
            </div>
            <div class="itemText">
              <div class="textItem">
                <span>分辨率：</span>
              </div>
              <div class="textItem">
                <span>{{ item.productDistinguishability }}</span>
              </div>
            </div>
            <div class="itemText">
              <div class="textItem">
                <span>价格：</span>
              </div>
              <div class="textItem">
                <span>{{item.goodsPriceType == 1?'￥'+item.goodsPrice:item.goodsPriceType == 2?'面议':'免费'}}</span>
              </div>
            </div>
            <div class="joinBuyCar">
              <el-button size="small" type="primary" icon="el-icon-shopping-cart-full" @click="joinBuyCar(item.goodsId)">加入购物车</el-button>
              <!-- <el-button size="small">12家供应商</el-button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 空列表展示 -->
      <div class="nothing" v-else>
        <div class="iconStyle">
          <el-empty description="无结果信息"></el-empty>
          <!-- <img :src="cartEmpty" alt=""> -->
        </div>
        <!-- <div class="title">
          <p>无结果信息</p>
        </div> -->
        <!-- <div class="info">
          <p>请条件查询后查看</p>
        </div> -->
      </div>
      <!-- 分页参数 -->
      <div class="paginationBox">
        <el-pagination background layout="prev, pager, next" :total="allTotal" :page-size="5" :current-page="currentPage" @current-change="changePageFun">
        </el-pagination>
      </div>
      <!-- 购物车信息 -->
      <div class="buyCarBox">
        <div class="item">
          <!-- <el-checkbox v-model="allChecked"></el-checkbox> -->
          <el-button type="primary" size="small" round plain @click="joinBuyCar">加入购物车</el-button>
        </div>
        <div class="item">
          <p>已选 <span class="itemNum">{{selectedImage.length}}</span> 景</p>
        </div>
        <div class="item">
          <el-button type="primary" @click="goBuyCar">前往购物车</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import cartEmpty from "@/assets/imgs/cart-empty.png";
  import WKTToGeoJson from "@/utils/WKTToGeoJson";
  export default {
    name: "mapResult",
    props: {
      seachParams: {
        type: Object,
        default: {},
      },
    },
    watch: {
      seachParams: {
        handler(newVal, oldVal) {
          console.log("接收到的查询参数：", newVal, this.currentState);
          // 当前为显示状态,去执行查询接口
          this.searchCondition = newVal;
          this.currentPage = 1;
          this.toolMapInfo = '';
          // 清除地图工具绘制数据
          this.$emit('clearSearch', '1');
          // 执行查询
          this.searchDataFun(newVal);
          if (!this.currentState) {
            // 当前为隐藏状态
            this.changeResult();
          } else {
            return;
          }
        },
      },
      "$store.state.productSearch.toolInfo": {
        handler: function(newVal, oldVal) {
          console.log("地图绘制工具数据发生变化啦"); //修改数据时，能看到输出结果
          // console.log(newVal, oldVal)
          // 清除地图工具绘制数据
          this.$emit('clearTools', '1');
          this.toolMapInfo = newVal;
          this.currentPage = 1;
          this.searchDataFun();
          if (!this.currentState) {
            // 当前为隐藏状态
            this.changeResult();
          } else {
            return;
          }
        }
      }
    },
    data() {
      return {
        joinCarLoad: false,
        searchDataLoading: false,
        // 空列表开关
        nothingSwitch: false,
        //   全选
        allChecked: false,
        cartEmpty,
        imageInfo: [
          { name: "采集时间", value: "2020-09-14" },
          { name: "卫星系列", value: "WG2022" },
          { name: "卫星名称", value: "长江一号" },
          { name: "云量", value: "30" },
          { name: "产品级别", value: "L2" },
          { name: "分辨率", value: "2m" },
          { name: "经纬度", value: ["109.948142454834", "41.69743652985384"] },
        ],
        btnText: "收起结果",
        resultState: false,
        currentState: false,
        iconSrc: "el-icon-s-fold",
        allTotal: 0,
        imageInfoData: [],
        currentPage: 1,
        searchCondition: {},
        // 存储已选择影像
        selectedImage: [],
        // 地图工具绘制信息
        toolMapInfo: '',
        // 存储当前已显示的图像id
        saveShowedImage: []
      };
    },
    created() {},
    mounted() {},
    methods: {
      // 购物车选择
      selectGoodFun(e) {
        if (this.selectedImage.length > 0) {
          const isExit = this.selectedImage.indexOf(e);
          if (isExit > 0 || isExit == 0) {
            // console.log('存在删除');
            this.selectedImage.splice(isExit, 1)
          } else {
            // console.log('不存');
            this.selectedImage.push(e)
          }
        } else {
          this.selectedImage.push(e)
        }
        console.log('当前勾选产品：', this.selectedImage);
      },
      //   结果显示隐藏
      changeResult() {
        this.resultState = true;
        this.currentState = !this.currentState;
        if (this.currentState == true) {
          this.iconSrc = "el-icon-s-unfold";
        } else {
          this.iconSrc = "el-icon-s-fold";
        }
        setTimeout(() => {
          this.resultState = false;
        }, 500);
      },
      // 查看详情
      lookDetail(id) {
        // console.log("查看详情");
        let routeUrl = this.$router.resolve({
          name: "shopDetail",
          query: {
            goodsId: id
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      noLogin() {
        this.$confirm("此操作需要登录, 是否跳转登录页面?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            this.$router.push({ path: `/login?redirect=${this.$route.fullPath}` });
          })
          .catch(() => {});
      },
      // 控制地图图像显示隐藏
      changeImageSwitchFun(val) {
        console.log('控制地图图像显示隐藏:', val);
        let saveInfo = {
          goodsInfo: val,
          time: new Date().getTime()
        }
        this.$store.dispatch('productSearch/updateImageSwitch', saveInfo)
      },
      joinBuyCar(id) {
        if (!this.$store.state.user.userInfo.id) {
          this.noLogin()
        } else {
          let sendData = [];
          // console.log(id,this.selectedImage);
          if (typeof(id) == 'string') {
            sendData = [{ "goodsId": id, "number": 1 }]
          } else {
            // return false;
            if (this.selectedImage.length > 0) {
              this.selectedImage.map(item => {
                sendData.push({ "goodsId": item, "number": 1 });
              })
            } else {
              this.$message.warning(this.$PubText.deleteShopWarning);
              return false;
            }
          }
          // this.joinCarLoad = true;
          this.$http.post(this.$const.RemoteSensingMall.shoppingCartaddItem, sendData)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$store.dispatch("shoppingCart/getCartINFO", {})
                this.$message.success(this.$PubText.joinBuyCarSuccess);
              } else {
                this.$message.error(this.$PubText.joinBuyCarFail);
              }
            })
            .catch((error) => {
              console.log(error);
              // this.$message.error(this.$PubText.InterfaceFail);
            }).finally(cms => {
              // this.joinCarLoad = false;
            });
        }


      },
      // 跳转购物车
      goBuyCar() {
        let routeUrl = this.$router.resolve({
          name: "shopCar"
        });
        window.open(routeUrl.href, '_blank');
      },
      // 修改页数[上下页数量页]
      changePageFun(e) {
        console.log("当前页码：", e);
        this.currentPage = e;
        this.searchDataFun();
      },
      // 执行查询数据接口
      searchDataFun(data) {
        let sendData = {};
        if (!data) {
          // 如果地图工具绘制了内容
          if (this.toolMapInfo.length > 2) {
            sendData = {
              pageNum: parseInt(this.currentPage),
              pageSize: 5,
              // 省级code
              provinceId: '',
              // 市级code
              cityId: '',
              // 区级code
              countyId: '',
              // 经纬度
              coordinateInfo: this.toolMapInfo,
              // 数据采集时间
              acquisitionStartTime: "",
              acquisitionEndTime: "",
              // 产品级别值
              productLevel: '',
              // 云量
              cloudCover: '',
              // 当前选中的分辨率
              productDistinguishabilityList: [],
              // 其他分辨率
              // otherResolveValue: this.otherResolveValue,
              // 卫星系列
              satelliteCategoryIdList: []
            };
          } else {
            this.searchCondition.pageNum = parseInt(this.currentPage);
            sendData = this.searchCondition;
          }

        } else {
          sendData = data;
        }
        this.searchDataLoading = true;
        this.$http
          .post(this.$const.searchOther.searchMapList, sendData)
          .then((res) => {
            // console.log("获取卫星影像数据:", res);
            if (res.code == 200) {
              this.allTotal = parseInt(res.data.total);
              this.imageInfoData = res.data.list;
              if (this.imageInfoData.length > 0) {
                this.nothingSwitch = true;
                let sendArrayGeojon = [];
                this.imageInfoData.map((ele) => {
                  // console.log('绘制地图边界信息：', ele);
                  let geojson = WKTToGeoJson(ele.coordinateInfo); //WKTToGeoJson(element.bounds);
                  geojson.id = ele.goodsId;
                  geojson.image = ele.goodsThumbnail;
                  geojson.geoCoord = ele.coordinateInfo;
                  // console.log('geojson数据：', geojson);
                  sendArrayGeojon.push(geojson)
                });
                setTimeout(item => {
                  this.addImageToMap(sendArrayGeojon);
                }, 200)
              } else {
                this.nothingSwitch = false;
              }
            } else {
              this.$message.error(this.$PubText.getInfoFail);
            }
          })
          .catch((error) => {
            this.$message.error(this.$PubText.InterfaceFail);
          }).finally(cms => {
            this.searchDataLoading = false;
            this.$emit('searchEnd', true);
          });
      },
      addImageToMap(obj) {
        this.$store.dispatch('productSearch/upImageInfo', obj);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mapResult {
    .resultBtn {
      position: fixed;
      top: 10vh;
      right: 2vh;
    }

    .animateLeft {
      right: 2vh !important;
    }

    .mapResultWrap {
      width: 450px;
      height: 70vh;
      position: fixed;
      top: 15vh;
      right: -450px;
      font-size: 14px;
      background: rgba($color: #ffffff, $alpha: 0.8);
      padding: 5px 5px 100px 5px;
      border-radius: 4px;
      box-sizing: border-box;
      transition: right ease-out 0.5s;
      -moz-transition: right ease-out 0.5s;
      /* Firefox 4 */
      -webkit-transition: right ease-out 0.5s;
      /* Safari and Chrome */
      -o-transition: right ease-out 0.5s;

      /* Opera */
      .resultTitle {
        height: 40px;
        line-height: 40px;
        background-color: #a3b8e4;
        color: rgb(29, 29, 29);

        .beforeIcon {
          width: 3px;
          height: 20px;
          float: left;
          margin-top: 10px;
          margin-left: 10px;
          background-color: rgb(29, 29, 29);
          margin-right: 4px;
        }
      }

      .nothing {
        text-align: center;

        .iconStyle {
          width: 50%;
          border-radius: 50%;
          background: rgba($color: #000, $alpha: 0);
          margin: 120px auto 0px;

          i {
            font-size: 80px;
            color: #ffffff;
            line-height: 80px;
          }
        }

        .title {
          margin-top: 20px;
          font-size: 16px;
          color: #303133;
        }

        .info {
          font-size: 14px;
          color: #6e6f70;
          line-height: 30px;
        }
      }

      .paginationBox {
        width: 445px;
        height: 50px;
        background: rgba($color: #ffffff, $alpha: 1);
        position: absolute;
        bottom: 50px;
        left: 0;
        display: flex;
        align-items: center;

        .el-pagination {
          margin-left: auto;
        }
      }

      .buyCarBox {
        width: 100%;
        height: 50px;
        background-color: #fafafa;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        text-align: center;
        border-radius: 4px;

        .item:nth-of-type(1) {
          flex: 1;

          .el-checkbox {
            margin-right: 10px;
          }
        }

        .item:nth-of-type(2) {
          flex: 1;
          color: #306ce2;

          .itemNum {
            color: red;
          }
        }

        .item:nth-of-type(3) {
          flex: 1;
        }
      }

      .resultList {
        width: 445px;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        overflow-y: auto;
        padding-bottom: 50px;

        .resultBox {
          width: 100%;
          height: 175px;
          padding: 5px 0px;
          background-color: rgba($color: #ffffff, $alpha: 0.8);
          margin-top: 10px;
          display: flex;
          position: relative;

          .joinBuyCar {
            position: absolute;
            bottom: 4px;
            right: 4px;
          }

          .item:nth-of-type(1) {
            flex: 3;
            height: 165px;

            .selectedSingleBuyCar {
              width: 100%;
              height: 165px;

              .imageClass {
                cursor: pointer;
                width: 100%;
                height: 165px;
                border-radius: 1px;
              }
            }

          }

          .item:nth-of-type(2):hover .rightArrow {
            display: block;
          }

          .item:nth-of-type(2) {
            flex: 5;
            height: 140px;
            overflow-y: auto;

            .rightArrow {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              text-align: center;
              line-height: 24px;
              background: rgba($color: #acaaaa, $alpha: 0.8);
              color: #ffffff;
              position: absolute;
              right: 10px;
              top: 60px;
              display: none;
              cursor: pointer;
            }

            .itemText {
              font-size: 12px;
              line-height: 20px;
              text-indent: 4px;
              display: flex;

              .textItem:nth-of-type(1) {
                flex: 1;
              }

              .textItem:nth-of-type(2) {
                flex: 3;
                display: flex;
                width: 0;

                span {
                  white-space: nowrap;
                  overflow: hidden; //文本超出隐藏
                  text-overflow: ellipsis; //文本超出省略号替代
                }
              }
            }
          }
        }
      }
    }
  }

  .resultBtn /deep/ .el-button {
    font-size: 16px !important;
    padding: 10px !important;
  }

  .selectedSingleBuyCar /deep/ .el-checkbox__label {
    // width: 100%;
    padding: 0 !important;
  }

  .selectedSingleBuyCar /deep/ .el-checkbox__input {
    // position: absolute;
    // top: 5px;
    // left: 5px;
  }

  .selectedSingleBuyCar /deep/ .el-checkbox {
    // width: 100%;
    position: absolute;
    top: 5px;
    left: 5px;
  }

  .check_Have {

    width: 15px;
    height: 15px;
    background: #409eff;
    position: absolute;
    top: 10px;
    left: 5px;
    cursor: pointer;
  }


  .check_Not {

    width: 15px;
    height: 15px;
    background: #fff;
    position: absolute;
    top: 10px;
    left: 5px;
    cursor: pointer;

  }
</style>